import { all } from "redux-saga/effects";
import watchGlobal from "../containers/global/sagas";
import watchAuth from "../containers/auth/sagas";
import watchDirectory from "containers/directory/sagas";
import watchConsult from "containers/consults/sagas";

export default function* root() {
  yield all([watchGlobal(), watchAuth(), watchDirectory(), watchConsult()]);
}
